"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    children: _propTypes.string.isRequired,
    textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    borderColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    hoverTextColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    hoverBackgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    hoverBorderColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    activeTextColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    activeBackgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    activeBorderColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    fontSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE),
    onChipClick: _propTypes.func,
    onSearchClick: _propTypes.func,
    onViewBookingsClick: _propTypes.func,
    url: _propTypes.string,
    newTab: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool]),
    disabled: _propTypes.bool,
    active: _propTypes.bool,
    isLoading: _propTypes.bool,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    customPadding: _propTypes.string,
    isMobile: _propTypes.bool,
    stationsObj: [_propTypes.object],
    showHotelRetriveBookingBanner: _propTypes.bool,
    showInvalidBookingBanner: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    textColor: _constant2.DEFAULT_CHIP_VALUES.TEXT_COLOR,
    backgroundColor: _constant2.DEFAULT_CHIP_VALUES.BACKGROUND_COLOR,
    borderColor: _constant2.DEFAULT_CHIP_VALUES.BORDER_COLOR,
    hoverTextColor: _constant2.DEFAULT_CHIP_VALUES.HOVER.TEXT_COLOR,
    hoverBackgroundColor: _constant2.DEFAULT_CHIP_VALUES.HOVER.BACKGROUND_COLOR,
    hoverBorderColor: _constant2.DEFAULT_CHIP_VALUES.HOVER.BORDER_COLOR,
    activeTextColor: _constant2.DEFAULT_CHIP_VALUES.ACTIVE.TEXT_COLOR,
    activeBackgroundColor: _constant2.DEFAULT_CHIP_VALUES.ACTIVE.BACKGROUND_COLOR,
    activeBorderColor: _constant2.DEFAULT_CHIP_VALUES.ACTIVE.BORDER_COLOR,
    onChipClick: function onChipClick() {},
    onSearchClick: function onSearchClick() {},
    onViewBookingsClick: function onViewBookingsClick() {},
    isLoading: false,
    newTab: 'TRUE',
    fontSize: _constant2.DEFAULT_CHIP_VALUES.FONT_SIZE,
    stationsObj: [],
    showHotelRetriveBookingBanner: false,
    showInvalidBookingBanner: false
  }
};
exports.default = _default;